<div fxFlexFill>
  <ng-template licensingTierTemplateInsert></ng-template>
</div>
